import React from 'react'

export const EditProfille = () => {
  return (
    <div>EditProfille</div>
  )
}
